import { render, staticRenderFns } from "./PageSelector.vue?vue&type=template&id=8ce023f0&scoped=true&"
import script from "./PageSelector.vue?vue&type=script&lang=js&"
export * from "./PageSelector.vue?vue&type=script&lang=js&"
import style0 from "./PageSelector.vue?vue&type=style&index=0&id=8ce023f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce023f0",
  null
  
)

export default component.exports